import { render } from "./ReferentAnnuaire.vue?vue&type=template&id=2c75c379"
import script from "./ReferentAnnuaire.vue?vue&type=script&lang=js"
export * from "./ReferentAnnuaire.vue?vue&type=script&lang=js"

import "./ReferentAnnuaire.vue?vue&type=style&index=0&id=2c75c379&lang=scss"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__